<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت طبقه‌بندی حفاظتی شغل</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">سطح حفاظت اطلاعات</label>
          <input
              type="text"
              class="form-control"
              placeholder="سطح را وارد کنید"
              v-model="newItem.information_protection_level"
          />
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">وضعیت</label>
          <select class="form-select" v-model="newItem.status">
            <option value="" disabled>وضعیت را انتخاب کنید</option>
            <option v-for="(status, index) in statuses" :key="index" :value="status">
              {{ status }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['سطح حفاظت اطلاعات', 'وضعیت']"
          :fields="['information_protection_level', 'status']"
          :items="protections"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش طبقه‌بندی حفاظتی"
          modal-id="protectionModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">سطح حفاظت اطلاعات</label>
            <input
                type="text"
                class="form-control"
                placeholder="سطح را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.information_protection_level"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">وضعیت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.status">
              <option value="" disabled>وضعیت را انتخاب کنید</option>
              <option v-for="(status, index) in statuses" :key="index" :value="status">
                {{ status }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";
import { Modal } from 'bootstrap';
import { useToast } from "vue-toastification";

const baseStructure = {
  information_protection_level: '',
  status: '',
};

const toast = useToast();

export default {
  components: { GeneralButton, GeneralTable, GeneralModal },

  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/protections/index',
      afterMutation: 'jobProtectionClassification/setProtections'
    });
  },

  data() {
    return {
      newItem: structuredClone(baseStructure),
      statuses: [
        'محرمانه',
        'عادی',
      ],
      editedItem: null,
      editIndex: null,
    };
  },

  computed: {
    protections: {
      get() {
        return this.$store.state.jobProtectionClassification.protections;
      },
      set(value) {
        this.$store.commit('jobProtectionClassification/setProtections', value);
      }
    },
  },

  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/protections/store',
      });

      this.protections = [...this.protections, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },

    removeItem(index) {
      const protection = this.protections.find((_, i) => i === index);
      this.protections = this.protections.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: protection.id,
        endpoint: '/protections/delete',
      });
    },

    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('protectionModalId'));
      modal.show();
    },

    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/protections/update',
      });

      this.protections.splice(this.editIndex, 1, { ...this.editedItem });
      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('protectionModalId'));
      modal.hide();
    },

    checkItemValidation(item) {
      if (!item.information_protection_level || !item.status) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    }
  }
};
</script>
